import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Esto requiere suplementos caros?',
  answer: 'No. El protocolo se basa en comida real que encuentras en cualquier súper. Los suplementos son opcionales y te enseñamos a elegir los más económicos y efectivos.'
}, {
  question: '¿Tengo que cocinar horas?',
  answer: 'En absoluto. Las recetas están diseñadas para mujeres ocupadas y se preparan en menos de 15 minutos.'
}, {
  question: '¿Funciona si ya pasé la menopausia?',
  answer: 'Sí. El balance hormonal es necesario a los 45, 55 y 65 años. Tu metabolismo te lo agradecerá siempre.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 sm:py-24 px-4 sm:px-6 lg:px-8 bg-cream" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <FadeIn data-id="element-36">
          <div className="text-center mb-8 sm:mb-16" data-id="element-37">
            <h2 className="text-2xl sm:text-4xl font-bold text-charcoal mb-2 sm:mb-4" data-id="element-38">
              Preguntas Frecuentes
            </h2>
            <p className="text-sm sm:text-lg text-charcoal-light" data-id="element-39">
              Resolvemos tus dudas antes de empezar.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-3 sm:space-y-4" data-id="element-40">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-41">
              <div className="bg-white rounded-xl sm:rounded-2xl shadow-sm border border-sage/20 overflow-hidden" data-id="element-42">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-3.5 sm:px-6 sm:py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-43">
                  <span className="font-bold text-sm sm:text-lg text-charcoal pr-4 sm:pr-8" data-id="element-44">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 sm:w-6 sm:h-6 text-sage flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-45" />
                </button>
                <AnimatePresence data-id="element-46">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-47">
                      <div className="px-4 pb-3.5 sm:px-6 sm:pb-5 text-charcoal-light leading-relaxed border-t border-cream-dark pt-3 sm:pt-4 text-sm sm:text-base" data-id="element-48">
                        <span className="font-bold text-sage mr-2" data-id="element-49">✅</span>
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}